<aside
  class="d-flex flex-column border-end vh-100 sidebar sidebarback"
  [ngClass]="{ 
    collapsed: isSidebarCollapsed && !isTemporarilyExpanded,
    'temp-expanded': isTemporarilyExpanded 
  }"
>
  <div class="d-flex flex-column align-items-center p-2 border-bottom" *ngIf="!isSidebarCollapsed || isTemporarilyExpanded">
    <!-- Logo -->
    <img
      [src]="trackingService.getpictureComp()"
      alt="BI Company"
      class="img-fluid sidebar-logo"
    />
  </div>

  <div class="flex-grow-1 overflow-auto p-2">
<!-- Select Root -->
    <select
      id="root"
      (change)="onRootsSelected($event)"
      (focus)="expandTemporarily()"
      (blur)="collapseAfterInteraction()"
      (click)="expandTemporarily()"
      class="form-select mb-2"
      [value]="selectedRoot || ''"
      [matTooltip]="isSidebarCollapsed && !isTemporarilyExpanded ? (('select' | translate) + ' ' + ('company' | translate)) : ''"
      matTooltipPosition="right"
    >
      >
      <option selected value="" disabled>{{ "company" | translate }}</option>
      <option *ngFor="let item of rootData" [value]="item.id">
        {{ item.name }}
      </option>
    </select>

<!-- Select Branchs -->
    <select
      id="branchs"
      (change)="onBranchSelected($event)"
      (focus)="expandTemporarily()"
      (blur)="collapseAfterInteraction()"
      (click)="expandTemporarily()"
      class="form-select mb-2"
      [value]="selectedBranchId"
      [matTooltip]="isSidebarCollapsed && !isTemporarilyExpanded ? (('select' | translate) + ' ' + ('branchs' | translate)) : ''"
      matTooltipPosition="right"
    >
      <option selected disabled value="">{{ "branchs" | translate }}</option>
      <option *ngFor="let item of branchData" [value]="'' + item.id">
        {{ item.name }}
      </option>
    </select>
    <span *ngIf="authService.hasDetailedPermission('principal', 'projects')">
      <span>Select Contracts</span>
<select
        id="contracts"
        (change)="onContractsSelected($event)"
        (focus)="expandTemporarily()"
        (blur)="collapseAfterInteraction()"
        (click)="expandTemporarily()"
        class="form-select mb-2"
        [value]="selectedContractId"
        [matTooltip]="isSidebarCollapsed && !isTemporarilyExpanded ? (('select' | translate) + ' ' + ('contract' | translate)) : ''"
        matTooltipPosition="right"
      >
        <option selected disabled value="">
          {{ "contract" | translate }}
        </option>
        <option *ngFor="let item of contractData" [value]="'' + item.contractId">
          {{ item.contract }}
        </option>
      </select>

      <!-- Convenio vigente — solo lectura, informativo -->
      <div *ngIf="conventionVigenteNombre" class="mb-2 mt-1 px-1"
           matTooltip="Convenio Vigente: {{ conventionVigenteNombre }}"
           matTooltipPosition="right">
        <small class="badge bg-success w-100 text-truncate d-block text-start py-1"
               style="font-size: 0.7rem;">
          <i class="bi bi-bookmark-check-fill me-1"></i>{{ conventionVigenteNombre }}
        </small>
      </div>

      <span>Select Projects</span>
      <select
        id="project"
        (change)="onProjectSelected($event)"
        (focus)="expandTemporarily()"
        (blur)="collapseAfterInteraction()"
        (click)="expandTemporarily()"
        class="form-select mb-2"
        [value]="selectedProjectId"
        [matTooltip]="isSidebarCollapsed && !isTemporarilyExpanded ? (('select' | translate) + ' ' + ('projects' | translate)) : ''"
        matTooltipPosition="right"
      >
        >
        <option selected disabled value="">
          {{ "projects" | translate }}
        </option>
        <option *ngFor="let pj of projectData" [value]="'' + pj.idProject">
          {{ pj.projectName }}
        </option>
      </select>

      <!-- Presupuesto vigente — solo lectura, informativo -->
      <div *ngIf="presupuestoVigenteNombre" class="mb-2 mt-1 px-1"
           matTooltip="Presupuesto Vigente: {{ presupuestoVigenteNombre }}"
           matTooltipPosition="right">
        <small class="badge bg-warning text-dark w-100 text-truncate d-block text-start py-1"
               style="font-size: 0.7rem;">
          <i class="bi bi-wallet2 me-1"></i>{{ presupuestoVigenteNombre }}
        </small>
      </div>

    </span>

    <ul class="nav flex-column">
      <li class="nav-item" *ngIf="authService.hasMasterPermission('dashboard')">
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/dashboardgrales']"
          routerLinkActive="active-link"
          (click)="Dashboard()"
          [matTooltip]="isSidebarCollapsed ? ('Dashboard' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>dashboard</mat-icon> <span>{{ "Dashboard" | translate }}</span>
        </a>
      </li>

      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('indicators')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/indicgrals']"
          routerLinkActive="active-link"
          (click)="Indicadores()"
          [matTooltip]="isSidebarCollapsed ? ('indicators' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>bar_chart</mat-icon> <span>{{ "indicators" | translate }}</span>
        </a>
      </li>

      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('administration')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/procmodadmon']"
          routerLinkActive="active-link"
          (click)="Admonproc()"
          [matTooltip]="isSidebarCollapsed ? ('admins' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>menu_book</mat-icon> <span>{{ "admins" | translate }}</span>
        </a>
      </li>

      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('shopping')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/proceswar']"
          routerLinkActive="active-link"
          (click)="warehouseproc()"
          [matTooltip]="isSidebarCollapsed ? ('buy' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>warehouse</mat-icon> <span>{{ "buy" | translate }}</span>
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('shoppingDelison')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/shoppingDelison']"
          routerLinkActive="active-link"
          (click)="warehouseproc()"
          [matTooltip]="isSidebarCollapsed ? ('buy' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>warehouse</mat-icon> <span>{{ "buy" | translate }}</span>
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('shoppingTD')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/shoppingTD']"
          routerLinkActive="active-link"
          (click)="warehouseproc()"
          [matTooltip]="isSidebarCollapsed ? ('buy' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>warehouse</mat-icon> <span>{{ "buy" | translate }}</span>
        </a>
      </li>

      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('warehouses')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/almacenes']"
          routerLinkActive="active-link"
          (click)="almacenesproc()"
          [matTooltip]="isSidebarCollapsed ? 'Almacenes' : ''"
          matTooltipPosition="right"
        >
          <mat-icon>inventory_2</mat-icon> <span>Almacenes</span>
        </a>
      </li>
      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('warehousesTD')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/warehousesTD']"
          routerLinkActive="active-link"
          (click)="almacenesproc()"
          [matTooltip]="isSidebarCollapsed ? 'Almacenes' : ''"
          matTooltipPosition="right"
        >
          <mat-icon>inventory_2</mat-icon> <span>Almacenes</span>
        </a>
      </li>

      <li
        class="nav-item"
        *ngIf="authService.hasMasterPermission('maintenance')"
      >
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/procmodmaintenance']"
          routerLinkActive="active-link"
          (click)="maintenanceproc()"
          [matTooltip]="isSidebarCollapsed ? ('maintenance' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>engineering</mat-icon> <span>{{ "maintenance" | translate }}</span>
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.hasMasterPermission('hr')">
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/procreshuman']"
          routerLinkActive="active-link"
          (click)="resourcesmenproc()"
          [matTooltip]="isSidebarCollapsed ? ('resourcesmen' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>diversity_3</mat-icon> <span>{{ "resourcesmen" | translate }}</span>
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.hasMasterPermission('sales')">
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/procsales']"
          routerLinkActive="active-link"
          (click)="salesproc()"
          [matTooltip]="isSidebarCollapsed ? ('sale' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>point_of_sale</mat-icon> <span>{{ "sale" | translate }}</span>
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.hasMasterPermission('projects')">
       <a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/projects']"
          routerLinkActive="active-link"
          (click)="openProjects($event)"
          [matTooltip]="isSidebarCollapsed ? ('projects' | translate) : ''"
          matTooltipPosition="right"    >
          <mat-icon>grading</mat-icon> <span>{{ "projects" | translate }}</span>
       </a>
      </li>

      <li class="nav-item" *ngIf="authService.hasMasterPermission('presupuestos')">
        <a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/presupuestos']"
          routerLinkActive="active-link"
          [matTooltip]="isSidebarCollapsed ? 'Presupuestos' : ''"
          matTooltipPosition="right"
        >
          <mat-icon>account_balance_wallet</mat-icon> <span>Presupuestos</span>
        </a>
      </li>

      <li class="nav-item" *ngIf="authService.hasMasterPermission('setup')">
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/smp']"
          routerLinkActive="active-link"
          (click)="SmpSetup()"
          [matTooltip]="isSidebarCollapsed ? ('setup' | translate) : ''"
          matTooltipPosition="right"
        >
          <mat-icon>settings</mat-icon> <span>{{ "setup" | translate }}</span>
        </a>
      </li>
      
      <li class="nav-item">
<a
          class="nav-link d-flex align-items-center"
          [routerLink]="['/login']"
          routerLinkActive="active-link"
          (click)="authService.logout()"
          [matTooltip]="isSidebarCollapsed ? 'Salir' : ''"
          matTooltipPosition="right"
        >
          <mat-icon>logout</mat-icon> <span>Salir</span>
        </a>
      </li>
    </ul>
  </div>

  <!-- Botón de colapsar en la parte inferior -->
  <div class="p-2 border-top">
    <!-- Logo pequeño cuando está colapsado -->
    <div *ngIf="isSidebarCollapsed && !isTemporarilyExpanded" class="collapsed-logo-container mb-2">
      <img
        [src]="trackingService.getpictureComp()"
        alt="BI Company"
        class="collapsed-logo"
      />
    </div>
    <button
      class="btn btn-collapse w-100"
      (click)="toggleSidebar()"
      [matTooltip]="isSidebarCollapsed ? 'Expandir menú' : 'Contraer menú'"
      matTooltipPosition="right"
    >
      <mat-icon>{{ isSidebarCollapsed ? "chevron_right" : "chevron_left" }}</mat-icon>
      <span *ngIf="!isSidebarCollapsed" class="ms-2">Contraer</span>
    </button>
  </div>
</aside>
